import { DataBean } from "../DataBean";

export class IncomeResponsible extends DataBean {


    public async getIncomeResponsibleCatalog(idIncomeResponsible:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getIncomeResponsibleCatalog_Number", [idIncomeResponsible]);
    }

  
    

 
}